import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, Mail, ShieldCheck, Video } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import LoginModal from '../components/modals/LoginModal';
import RegisterModal from '../components/modals/RegisterModal';
import ForgotPasswordModal from '../components/modals/ForgotPasswordModal';
import { trackFirstPartyEventOnce } from '../lib/firstPartyAnalytics';

const VkLandingV2 = () => {
  const [showRegister, setShowRegister] = useState(true);
  const [showLogin, setShowLogin] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    trackFirstPartyEventOnce('landing_view', `vk2:${window.location.pathname}`);
  }, []);

  useEffect(() => {
    if (!isAuthenticated) return;
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    navigate(userData?.email?.includes('admin') ? '/admin' : '/videochat');
  }, [isAuthenticated, navigate]);

  const openRegistration = () => {
    trackFirstPartyEventOnce('registration_cta_click', `vk2:${window.location.pathname}`);
    setShowRegister(true);
  };

  return (
    <div className="relative min-h-[100dvh] overflow-hidden bg-gradient-to-b from-[#F3F6FF] via-white to-[#FFF1F3] px-4">
      <div className="pointer-events-none absolute -right-20 -top-24 h-64 w-64 rounded-full bg-[#7B61FF]/10 blur-2xl" />
      <div className="pointer-events-none absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-[#FF5757]/10 blur-2xl" />

      <main className="relative z-10 mx-auto flex min-h-[100dvh] w-full max-w-md flex-col justify-center py-6">
        <div className="mb-5 flex items-center justify-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-[#1A73E8] to-[#7B61FF] shadow-lg">
            <Heart className="h-6 w-6 fill-white text-white" aria-hidden="true" />
          </div>
          <span className="text-2xl font-extrabold tracking-tight text-[#1F1F1F]">Speed-Date</span>
        </div>

        <section className="rounded-[2rem] border border-white/80 bg-white/95 p-6 text-center shadow-2xl shadow-[#6A9EFF]/15 backdrop-blur sm:p-8">
          <p className="inline-flex rounded-full bg-[#EAF2FF] px-3 py-1 text-sm font-semibold text-[#1A73E8]">
            Знакомства 18+ в живом формате
          </p>
          <h1 className="mt-4 text-4xl font-extrabold leading-[1.08] tracking-tight text-[#1F1F1F]">
            Видеознакомства без номера телефона
          </h1>
          <p className="mt-4 text-lg leading-7 text-[#5F6368]">
            Создайте аккаунт по email и переходите к коротким видеосвиданиям
          </p>

          <ul className="mx-auto mt-6 max-w-xs space-y-3 text-left text-[15px] font-medium text-[#36383B]" aria-label="Преимущества Speed-Date">
            <li className="flex items-center gap-3"><Video className="h-5 w-5 flex-none text-[#1A73E8]" aria-hidden="true" />До 10 минут на видеознакомство</li>
            <li className="flex items-center gap-3"><Mail className="h-5 w-5 flex-none text-[#7B61FF]" aria-hidden="true" />Для регистрации достаточно email</li>
            <li className="flex items-center gap-3"><ShieldCheck className="h-5 w-5 flex-none text-[#34A853]" aria-hidden="true" />Личный чат — при взаимной симпатии</li>
          </ul>

          <button type="button" onClick={openRegistration} className="mt-7 min-h-14 w-full rounded-full bg-gradient-to-r from-[#FF5757] to-[#FF7B7B] px-6 py-4 text-lg font-bold text-white shadow-lg shadow-[#FF5757]/20 active:scale-[0.99]" data-testid="vk2-register-button">
            Начать регистрацию
          </button>
          <button type="button" onClick={() => setShowLogin(true)} className="mt-3 w-full py-2 text-sm font-medium text-[#5F6368] underline-offset-4 hover:text-[#1A73E8] hover:underline">
            Уже есть аккаунт? Войти
          </button>
        </section>
      </main>

      <RegisterModal
        isOpen={showRegister}
        onClose={() => setShowRegister(false)}
        onSwitchToLogin={() => { setShowRegister(false); setShowLogin(true); }}
      />
      <LoginModal
        isOpen={showLogin}
        onClose={() => setShowLogin(false)}
        onSwitchToRegister={() => { setShowLogin(false); openRegistration(); }}
        onForgotPassword={() => { setShowLogin(false); setShowForgotPassword(true); }}
      />
      <ForgotPasswordModal
        isOpen={showForgotPassword}
        onClose={() => setShowForgotPassword(false)}
        onBackToLogin={() => { setShowForgotPassword(false); setShowLogin(true); }}
      />
    </div>
  );
};

export default VkLandingV2;
